/**
 * Shared FE sortConfig → API { orderBy, sortDirection } mapper.
 * @param {Record<string, { direction?: string }> | null | undefined} sortConfig
 * @param {Record<string, string>} fieldMap
 * @param {boolean} enabled
 */
export function sortConfigToApiParams(sortConfig, fieldMap, enabled = true) {
  if (!enabled) return undefined;
  const key = Object.keys(sortConfig || {})[0];
  if (!key) return undefined;
  const direction = sortConfig[key]?.direction;
  if (direction !== "asc" && direction !== "desc") return undefined;
  const orderBy = fieldMap?.[key];
  if (!orderBy) return undefined;
  return { orderBy, sortDirection: direction };
}

export function pickTabSortParams(activeTab, orgParams, userParams) {
  return activeTab === "organizations" ? orgParams : userParams;
}

export function selectActiveAdminTabItems(activeTab, orgItems, userItems) {
  return activeTab === "organizations" ? orgItems ?? [] : userItems ?? [];
}

export function withOrgSortPayload(payload, orgSortParams) {
  if (!orgSortParams?.orderBy) return payload;
  return {
    ...payload,
    sort_by: orgSortParams.orderBy,
    sort_direction: orgSortParams.sortDirection,
  };
}
